// extracted by mini-css-extract-plugin
module.exports = {"invalid_tenant":"styles_invalid_tenant__2fLKy","invalid_tenant__message":"styles_invalid_tenant__message__27wQy"};